<!-- 跨仓合并包 -->
<template>
<el-dialog :title="msg('跨仓合并包')" :visible.sync="visible" 
    :fullscreen="isMinScreen" 
    :close-on-click-modal="false" 
    width="400px"
>
    <el-row class="wrap-panel">
        <span class="plabel">{{msg('仓库')}}</span>
        <el-select v-model="storeId" filterable placeholder="请选择首发仓库" size="mini"
            clearable
        >
            <el-option
                v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <div style="text-align:center; margin-top:20px;">
            <el-button type="primary" size="mini"  @click="doSubmint"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
            <el-button  size="mini" v-on:click="visible=false">{{msg('取消')}}</el-button>
        </div>
    </el-row> 
</el-dialog>
</template>
<script>
export default {
    name: 'StockStartPkgType',
    mounted: function(){
    },
    data(){
        return {
            visible: false,
            storeId: null,
            stores: null,
            ids: null,
            callback: null,
        }
    },
    // props:{
    //     ids:String
    // },
    computed: {
        isMinScreen:{
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    methods:{
        showDialog(ids, callback){
            this.storeId = null;
            this.stores = null;
            this.ids = ids;
            this.getStores();
            this.visible = true;
            this.callback = callback;
        },
        getStores(){
            this.$axios.post(
                this.$kit.api.store.listUsed
            ).then((result)=> {
                if(result.status){
                    this.stores = result.data;
                }
            });
        },
        doSubmint(){
            if(!this.storeId){
                this.$message(this.msg('请选择仓库'));
                return;
            }
            this.$axios.post(this.$kit.api.updateColumn.updatePkgTypeToKuaCang
                +'?ids='+this.ids
                +'&storeId='+this.storeId
            ).then((result) =>{
                if(result.status){
                    this.$message(result.msg || this.msg('更新成功'));
                    this.visible = false;
                    if(this.callback){
                        this.callback();
                    }
                }else{
                    this.$message(result.msg || this.msg('更新失败'));
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.plabel{display:inline-block; margin-left: 15px; margin-right:10px;}
.pintpu{width:300px; max-width:300px;}
</style>